import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import config from './config.js';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

const domain = config.AWS_COGNITO_CLIENT_DOMAIN;

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID, // REQUIRED - Amazon Cognito Identity Pool ID
      loginWith: {
        oauth: {
          domain,
          scopes: [
            'openid',
            'email',
            'profile',
            'https://translate-api-deve.nprd-astrazeneca.com/az-eu-west-1-646007916794-ecs-deve-translate-redesign-integration',
          ],
          redirectSignIn: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/callback`,
            'http://localhost:4200/auth/callback',
          ],
          redirectSignOut: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/login`,
            'http://localhost:4200/auth/login',
          ],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};
Amplify.configure(awsConfig);
